import { UserData } from '@partoohub/api-client';

import { useAppDataContext } from './private/useAppDataContext';

export const useMe = (): UserData => {
    return useAppDataContext().me;
};
